module.exports = __webpack_public_path__ + "static/media/PA.b822f734.png";